import Constants from '@/consts/planDesign.constants';
import Helper from '@/routes/plans/plan-detail/PlanTab/Helper';

class HasPdmp {
  convertToApiState = Helper.convertFromYesNoToBoolean;

  isHidden: boolean | undefined;

  options = Constants.yesNoOptions;

  output: string | undefined;

  set(hasPdmp: boolean, isJpm: boolean, tpaId: number) {
    this.output = Helper.convertFromBooleanToYesNo(hasPdmp);

    this.isHidden = isJpm || tpaId !== 1;
  }

  constructor() {}
}

export default HasPdmp;
